import { NextIcon } from "@/components/ui/icon";   
import { cn } from "@/utils/cn";
import { ComponentPropsWithoutRef, forwardRef } from "react";

interface NextButtonProps extends ComponentPropsWithoutRef<"button"> {
  className?: string;
}

const NextButton = forwardRef<HTMLButtonElement, NextButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "group flex items-center justify-center w-10 h-10 bg-white/50 rounded-sm hover:bg-white/80",
          className
        )}
        tabIndex={-1}
        {...props}
      >
        <NextIcon className="w-6 h-6" />
      </button>
    );
  }
);

NextButton.displayName = "NextButton";

export default NextButton;
